import React, { FC } from 'react';

import { RolloutTarget } from '../../../../lib/PlannerDTOs';

import './RolloutDiffBlock.css';

interface RolloutDiffBlockProps {
  target: RolloutTarget;
}

const RolloutDiffBlockV3: FC<RolloutDiffBlockProps> = () => {
  return <></>;
};

export default RolloutDiffBlockV3;
